import { Button, Form, Input, InputNumber, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import validateMessages from "../../utils/validate";
import { editMasterData } from "../../redux/actions/salesDataActions";
import { RootState } from "../../redux/rootReducer";
import { Actions } from "../../shared/constant";
import globalUtils from "../../utils/globalUtils";

interface Item {
  [key: string]: string;
}
interface ModalFormProps {
  visible: boolean;
  onCancel: () => void;
  editData: Item;
}

function MasterDataEditModal({ visible, onCancel, editData }: ModalFormProps) {
  const dispatch = useDispatch();
  const { pending, fulfilled } = useSelector(
    (state: RootState) => state.salesData,
  );

  const [form] = Form.useForm();
  const [action, setAction] = useState("");

  // useEffect(() => {
  //   console.log("useEffect: MasterDataEditModal", form.getFieldsValue());
  // }, []);

  useEffect(() => {
    // console.log("Edit DATA", editData);
    form.setFieldsValue(editData);
  }, [editData]);

  useEffect(() => {
    if (action === Actions.EDIT) {
      // console.log("___________________ onCancel()");
      onCancel();
      setAction("");
    }
  }, [fulfilled]);

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        console.log(values);
        if (values.artist_name) {
          values.artist_name = globalUtils.joinByCommaWithSpace(
            values.artist_name,
          );
        }
        if (values.lyricist) {
          values.lyricist = globalUtils.joinByCommaWithSpace(values.lyricist);
        }
        if (values.composer) {
          values.composer = globalUtils.joinByCommaWithSpace(values.composer);
        }
        dispatch(editMasterData(editData.id, values));
        setAction(Actions.EDIT);
        // form.resetFields();
      })
      .catch(() => {});
  };

  return (
    <Modal
      visible={visible}
      title="Edit Master Data"
      centered
      width={740}
      onOk={onOk}
      onCancel={onCancel}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={pending as boolean}
          onClick={onOk}
        >
          Save
        </Button>,
      ]}
    >
      <div className="mx-6 mt-6 mb-[26px]">
        <Form
          form={form}
          preserve
          layout="vertical"
          name="masterDataEditForm"
          validateMessages={validateMessages}
        >
          {/* TODO specify required fileds */}
          <div className="grid grid-cols-2 gap-x-6">
            <Form.Item
              name="label_name"
              label="Label Name"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="album" label="Album">
              <Input />
            </Form.Item>
            <Form.Item
              name="track_title"
              label="Track Title"
              rules={[{ required: true }]}
            >
              <Input.TextArea />
            </Form.Item>
            <Form.Item name="artist_name" label="Artist Name">
              <Input />
            </Form.Item>
            <Form.Item name="lyricist" label="Lyricist">
              <Input />
            </Form.Item>
            <Form.Item name="composer" label="Composer">
              <Input />
            </Form.Item>
            <Form.Item name="quantity" label="Quantity">
              <InputNumber className="w-full" />
            </Form.Item>
            <Form.Item
              name="net_revenue"
              label="Net Revenue"
              rules={[{ required: true }]}
            >
              <InputNumber className="w-full" />
            </Form.Item>
            {editData?.is_valid_data || (
              <Form.Item
                name="content_id"
                label="Content ID"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            )}
          </div>
        </Form>
      </div>
    </Modal>
  );
}

export default MasterDataEditModal;
